import React, { createContext, useContext, useState, useMemo } from 'react';

const AptDataContext = createContext();

export const AptDataProvider = ({ children }) => {
  const [aptMetrixInfo, setAptMetrixInfo] = useState(null);
  const [isFetchingAptMetrixInfo, setIsFetchingAptMetrixInfo] = useState(false);
  const [aptMetrixInfoFetchError, setAptMetrixInfoFetchError] = useState(false);

  const resetAptDataState = () => {
    setAptMetrixInfo(null);
    setIsFetchingAptMetrixInfo(false);
    setAptMetrixInfoFetchError(false);
  };

  return (
    <AptDataContext.Provider
      value={useMemo(() => ({
        aptMetrixInfo, setAptMetrixInfo,
        isFetchingAptMetrixInfo, setIsFetchingAptMetrixInfo,
        aptMetrixInfoFetchError, setAptMetrixInfoFetchError,
        resetAptDataState,
      }), [aptMetrixInfo, isFetchingAptMetrixInfo, aptMetrixInfoFetchError])}
    >
      {children}
    </AptDataContext.Provider>
  );
};

export const useAptDataContext = () => useContext(AptDataContext);
